<header class="ph">
  <!-- Where this page lives: parent pages only; the title below names the current one -->
  @if (breadcrumbs.length) {
    <nav class="ph-trail" aria-label="Ruta de navegación">
      <ol>
        @for (crumb of breadcrumbs; track crumb.url; let first = $first) {
          <li>
            @if (!first) {
              <span class="ph-trail__sep" aria-hidden="true">/</span>
            }
            <a [routerLink]="[crumb.url]" class="ph-trail__link">
              @if (first) {
                <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
              }
              {{ crumb.name }}
            </a>
          </li>
        }
        <li class="sr-only" aria-current="page">{{ title }}</li>
      </ol>
    </nav>
  }

  <div class="ph-main">
    <div class="min-w-0">
      <h1 class="ph-title">{{ title }}</h1>
      @if (subtitle) {
        <p class="ph-subtitle">{{ subtitle }}</p>
      }
    </div>
    <div class="ph-actions">
      <ng-content select="[pageActions]"></ng-content>
    </div>
  </div>
</header>
